module.exports = __webpack_public_path__ + "img/painting.b6c3b7f7.png";